import { Box } from '@material-ui/core';
import { PaymentMethodType } from '@nemuru-eng/js-api-client';

import { IconByAllowedPaymentMethodType } from '@/components/shared/components/PricingsTable/constants/IconByAllowedPaymentMethodType';
import { Icon } from '@/components/shared/components/Icon';
import { Text } from '@/components/shared/components/Text';

export const PaymentMethodSelectOptions = (paymentMethods: PaymentMethodType[]) => {
  return Object.values(paymentMethods).map((value) => ({
    value,
    display: (
      <Box display={'flex'} flexDirection={'row'} gridGap={8} alignItems={'center'}>
        <Icon size={18}>{IconByAllowedPaymentMethodType(value)}</Icon>
        <Text tId={value} />
      </Box>
    ),
  }));
};
